import React from "react"
import { useSelector } from "react-redux"

import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import dayjs from "dayjs"

const TimeSlotsHeader = () => {
  const currentWeek = useSelector(
    (state: any) => state.weekPagination.currentWeek,
  )

  const today = dayjs()

  const startOfWeek = dayjs(currentWeek).startOf("week")
  const endOfWeek = dayjs(currentWeek).endOf("week")

  const daysInWeek = []
  let currentDay = startOfWeek

  while (
    currentDay.isBefore(endOfWeek) ||
    currentDay.isSame(endOfWeek, "day")
  ) {
    daysInWeek.push(currentDay)
    currentDay = currentDay.add(1, "day")
  }

  return (
    <TableRow
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgb(55, 55, 55)"
            : "rgba(225, 225, 225, 1)",
        height: "57px",
        borderBottom: "10px solid rgba(230, 230, 230, 1)",
      }}
    >
      <TableCell
        sx={{
          fontSize: "14px",
          fontWeight: "bold",
          borderRadius: "4px 0 0 4px",
        }}
      >
        Данные собеседующего
      </TableCell>
      {daysInWeek.map((item) => (
        <TableCell
          key={item.format("YYYY-MM-DD")}
          sx={{
            lineHeight: "1.2",
            fontSize: "14px",
            fontWeight: "bold",
            bgcolor: today.isSame(item, "day") ? "rgba(202, 227, 200, 1)" : "",
            color: today.isSame(item, "day") ? "#1B9C18" : "inherit",
            ":last-of-type": {
              borderRadius: "0px 4px 4px 0px",
            },
            width: "130px",
          }}
        >
          {dayjs(item).format("dd")[0].toUpperCase()}
          {dayjs(item).format("dd")[1]} {dayjs(item).format("DD.MM")}
        </TableCell>
      ))}
    </TableRow>
  )
}

export default TimeSlotsHeader
